export function renderFooter() {
  const footer = document.getElementById('main-footer');
  if (!footer) return;

  footer.innerHTML = `
    <div class="footer-inner">
      <div class="footer-brand-col">
        <a href="#home" class="footer-logo-link">
          <img src="/assets/logo.png" alt="Walk Together Ministries" class="footer-logo-img" />
          <span class="footer-brand-text">Walk Together Ministries</span>
        </a>
        <p class="footer-tagline">
          Don’t do life alone. We are a community of believers committed to making disciples, providing biblical resources, and walking through darkness together.
        </p>
        <div class="footer-nonprofit-callout">
          <i class="fa-solid fa-heart" style="color:var(--accent-rose); margin-right:6px;"></i>
          Partnering with <a href="https://walktogethercare.org" target="_blank" rel="noopener noreferrer">Walk Together Care</a> (501c3)
        </div>
      </div>

      <div class="footer-links-grid">
        <div class="footer-col">
          <h4 class="footer-heading">Ministries</h4>
          <ul class="footer-list">
            <li><a href="#home">Home</a></li>
            <li><a href="#course">Discipleship 101</a></li>
            <li><a href="#studies">Bible Studies</a></li>
            <li><a href="#blog">Blog & Reflections</a></li>
            <li><a href="#praytogether">PrayTogether App</a></li>
          </ul>
        </div>

        <div class="footer-col">
          <h4 class="footer-heading">Discipleship Tools</h4>
          <ul class="footer-list">
            <li><a href="#course">23 Cohort Lessons</a></li>
            <li><a href="#verses">21 Memory Verses</a></li>
            <li><a href="#dashboard">Student Dashboard</a></li>
            <li><a href="https://youtu.be/jTBBuirYxNo" target="_blank" rel="noopener noreferrer">Intro Video <i class="fa-brands fa-youtube" style="color:#ef4444; margin-left:4px;"></i></a></li>
          </ul>
        </div>

        <div class="footer-col">
          <h4 class="footer-heading">Partnership</h4>
          <ul class="footer-list">
            <li><a href="https://walktogethercare.org" target="_blank" rel="noopener noreferrer">WalkTogetherCare.org <i class="fa-solid fa-arrow-up-right-from-square" style="font-size:0.75rem;"></i></a></li>
            <li><a href="#home#beliefs">Our Beliefs</a></li>
            <li><a href="mailto:info@walktogetherministries.com">Contact Us</a></li>
          </ul>
        </div>
      </div>
    </div>

    <div class="footer-bottom-bar">
      <div class="wt-container footer-bottom-inner">
        <p class="footer-copyright">
          Copyright 2023 – Walk Together Ministries. All rights reserved.
        </p>
        <div class="footer-bottom-links">
          <span>Walk Through Darkness Together</span>
        </div>
      </div>
    </div>
  `;
}
